import React from 'react';
import StatCard from './StatCard';
import './StatsGrid.css';

function formatWeeklyStudyTime(totalSeconds) {
    if (!totalSeconds) return "+0m esta semana";
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    if (hours > 0) return `+${hours}h ${minutes}m esta semana`;
    return `+${minutes}m esta semana`;
}

function StatsGrid({ summaryData, totalStudyTime }) {
    // SUTURA DE SEGURIDAD MÚLTIPLE (?.?.||)
    const completedLessonsCount = summaryData?.lessons_progress?.filter(l => l.percentage >= 100)?.length || 0;

    return (
        <div className="dp-stats-grid">
            <StatCard 
                title="Puntos Totales"
                icon="⭐"
                value={summaryData?.total_xp || 0} // 🔥 CORRECCIÓN: snake_case (total_xp)
                changeText={`+${summaryData?.weekly_xp_change || 0} esta semana`}
                changeType="positive"
            />
            <StatCard 
                title="Racha Actual"
                icon="🔥"
                value={`${summaryData?.current_streak || 0} días`}
                changeText={`Mejor racha: ${summaryData?.best_streak || 0} días`}
                changeType="positive"
            />
            <StatCard 
                title="Lecciones Completadas"
                icon="📚"
                value={completedLessonsCount} // Usamos la variable segura
                changeText={`+${summaryData?.weekly_lessons_completed || 0} esta semana`}
                changeType="positive"
            />
            <StatCard 
                title="Tiempo de Estudio"
                icon="⏱️"
                value={totalStudyTime || "0m"}
                changeText={formatWeeklyStudyTime(summaryData?.weekly_study_seconds)}
                changeType="positive"
            />
        </div>
    );
}

export default StatsGrid;